export function normalizeText(value) {
  return String(value || '')
    .toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s._-]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim();
}

export function generateUsernameFromName(fullName) {
  const normalized = normalizeText(fullName);
  if (!normalized) {
    return 'guru';
  }

  const parts = normalized.split(' ').filter(Boolean);
  const first = parts[0];
  const second = parts[1];

  if (!second) {
    return first.replace(/[^a-z0-9]/g, '') || 'guru';
  }

  const username = `${first}_${second}`
    .replace(/[^a-z0-9_]/g, '')
    .replace(/_+/g, '_')
    .replace(/^_+|_+$/g, '');

  return username || first.replace(/[^a-z0-9]/g, '') || 'guru';
}
